import { jsx as _jsx } from "react/jsx-runtime";
var Eye = function Eye(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size - 1,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16.002 18c-1.102 0-2-.897-2-2 0-1.102.897-2 2-2s2 .898 2 2c0 1.103-.897 2-2 2Zm0-6.666A4.672 4.672 0 0 0 11.335 16a4.672 4.672 0 0 0 4.667 4.667A4.672 4.672 0 0 0 20.67 16a4.672 4.672 0 0 0-4.667-4.666Zm.293 11.33c-5.742.133-9.487-4.778-10.73-6.67 1.368-2.14 4.814-6.521 10.145-6.657 5.719-.145 9.486 4.777 10.728 6.67-1.366 2.14-4.813 6.52-10.143 6.657Zm12.865-7.327c-.85-1.483-5.55-8.915-13.518-8.665-7.371.186-11.658 6.68-12.797 8.665-.236.41-.236.916 0 1.327.839 1.462 5.372 8.669 13.19 8.669.11 0 .219-.001.328-.004 7.37-.188 11.658-6.68 12.797-8.665.235-.411.235-.916 0-1.327Z",
      fill: color
    })
  });
};
export default Eye;